/** Mobile portrait/landscape pill styling (borders for special types; web table keeps gradients). */

export const getMobilePillAppearance = (payBankAccount) => {
  if (!payBankAccount) {
    return { className: 'pill-zero', style: {} };
  }
  const amount = parseFloat(payBankAccount.transfer_amount);
  if (amount === 0 || payBankAccount.transfer_amount === '0.00') {
    return { className: 'pill-zero', style: {} };
  }

  const baseClass = payBankAccount.transfer_made ? 'pill-paid' : 'pill-unpaid';

  if (payBankAccount.transfer_option === 'unallocated') {
    return { className: `${baseClass} pill-border-unallocated`, style: {} };
  }
  if (payBankAccount.transfer_option === 'remaining') {
    return { className: `${baseClass} pill-border-remaining`, style: {} };
  }

  return { className: baseClass, style: {} };
};

export const formatPillLabel = (payBankAccount) => {
  if (!payBankAccount) return '—';
  if (payBankAccount.transfer_amount === '0.00' || parseFloat(payBankAccount.transfer_amount) === 0) {
    return '—';
  }
  return `$${payBankAccount.transfer_amount}`;
};
